export default __webpack_public_path__ + "static/media/export-blanco.aaf2f458.svg";